exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-content[data-v-c18a1a54] {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.detail-table .el-table__body-wrapper[data-v-c18a1a54] {\n  max-height: 400px;\n  overflow-y: auto;\n}\n.detail-table .label-text[data-v-c18a1a54] {\n  font-weight: bold;\n  font-size: 14px;\n}\n.detail-table .value-text[data-v-c18a1a54] {\n  font-size: 14px;\n}\n", ""]);

// exports
